import React, { ReactElement } from 'react';
import styles from '../../uibuilder/webtheme/widgets/ConfirmPopup.module.scss';
import { Button, ButtonColor, ButtonSize, usePopupManager } from 'ui-builder';
import { Popup } from 'features/nekst-widgets';

export interface ConfirmActionPopupProps {
  title: string
  message: string | ReactElement,
  submitFormFunc: () => Promise<void>,
  buttonText?: string,
}

export default function ConfirmWarningActionPopup(
  props: ConfirmActionPopupProps,
) {
  const popupManager = usePopupManager();

  const submitFunc = async () => {
    await props.submitFormFunc();
    popupManager.closePopup();
  };

  return (
    <Popup
      title={props.title}
      content={
        <div className={styles.message}>{props.message}</div>
      }
      buttons={(
        <Button
          key="confirm"
          text={props.buttonText || 'Confirm'}
          onClick={submitFunc}
          color={ButtonColor.YELLOW}
          size={ButtonSize.BIG}
        />
      )}
    />
  );
}
